export const Role = ['User', 'Admin'];
